var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g3, _path29, _g4, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 675.000002",
    height: 900,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8925ab655b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.554688 15.066406 L 749.445312 15.066406 L 749.445312 389 L 0.554688 389 Z M 0.554688 15.066406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5b59f3dd1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 671 350 L 749.445312 350 L 749.445312 396 L 671 396 Z M 671 350 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a454498150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.554688 386 L 749.445312 386 L 749.445312 404 L 0.554688 404 Z M 0.554688 386 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9684d07a79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.554688 403 L 749.445312 403 L 749.445312 479.378906 L 0.554688 479.378906 Z M 0.554688 403 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8925ab655b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8e2e3",
    d: "M 374.914062 14.996094 C 168.292969 14.996094 0.800781 182.035156 0.800781 388.085938 L 749.03125 388.085938 C 749.03125 182.035156 581.53125 14.996094 374.914062 14.996094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5b59f3dd1b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#655551",
    d: "M 749.03125 395.011719 L 671.140625 395.011719 L 671.140625 350.953125 L 749.03125 350.953125 L 749.03125 395.011719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#151c27",
    d: "M 744.039062 350.953125 C 742.78125 351.472656 668.734375 350.953125 668.734375 350.953125 L 622.703125 349.371094 L 630.449219 326.808594 L 707.089844 328.378906 L 744.039062 350.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#151c27",
    d: "M 118.773438 270.96875 L 89.921875 307.523438 L 68.410156 307.523438 L 78.597656 319.710938 L 78.597656 334.054688 L 313.359375 334.054688 L 313.359375 345.628906 L 526.734375 345.628906 L 507.726562 317.609375 L 366.195312 265.402344 C 366.195312 265.402344 301.28125 134.019531 258.253906 121.941406 C 258.253906 121.941406 274.304688 205.558594 268.945312 252.15625 L 187.296875 176.289062 L 191.824219 223.09375 L 80.113281 207.316406 L 118.773438 270.96875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2c32",
    d: "M 182.222656 307.523438 C 182.222656 307.523438 127.597656 230.214844 75.496094 203.324219 C 75.496094 203.324219 107.011719 257.105469 115.414062 276.011719 L 118.773438 270.96875 C 118.773438 270.96875 95.199219 225.253906 86.839844 215.085938 C 86.839844 215.085938 131.800781 242.816406 178.015625 310.046875 L 182.222656 307.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ece9ea",
    d: "M 182.222656 167.1875 C 182.222656 167.1875 279.28125 175.167969 332.226562 242.816406 C 332.226562 242.816406 345.25 261.304688 358.273438 341.558594 L 350.292969 341.558594 C 350.292969 341.558594 338.109375 315.507812 336.847656 314.667969 C 335.585938 313.828125 293.988281 307.523438 293.988281 307.523438 L 284.996094 329.585938 L 277.601562 329.585938 C 277.601562 329.585938 257.917969 245.8125 182.222656 167.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7c7f7c",
    d: "M 277.601562 329.585938 C 277.601562 329.585938 263.3125 247.4375 182.222656 167.1875 C 182.222656 167.1875 190.203125 208.78125 189.785156 219.707031 L 194.828125 219.707031 C 194.828125 219.707031 192.730469 191.96875 189.363281 181.472656 C 189.363281 181.472656 248.191406 239.332031 272.136719 327.566406 L 277.601562 329.585938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ece9ea",
    d: "M 75.496094 203.324219 C 75.496094 203.324219 178.183594 188.464844 236.621094 244.582031 C 236.621094 244.582031 262.238281 284.933594 272.738281 327.789062 L 255.933594 321.585938 L 244.828125 299.960938 L 198.1875 289.875 L 193.984375 307.101562 L 182.222656 307.523438 C 182.222656 307.523438 128.859375 230.632812 75.496094 203.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d2",
    d: "M 408.1875 312.054688 L 422.683594 256.683594 L 364.308594 341.558594 L 379.296875 341.558594 L 408.1875 312.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ece9ea",
    d: "M 422.683594 256.683594 C 422.683594 256.683594 419.664062 298.992188 364.308594 341.558594 C 364.308594 341.558594 346.96875 193.929688 253.234375 112.144531 C 253.234375 112.144531 372.863281 130.25 422.683594 256.683594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#7c7f7c",
    d: "M 253.234375 112.144531 C 253.234375 112.144531 339.394531 169.414062 364.308594 341.558594 L 358.273438 341.558594 C 358.273438 341.558594 339.648438 203.015625 262.21875 126.445312 C 262.21875 126.445312 270.25 147.769531 272.136719 194.339844 L 263.40625 190.042969 C 263.40625 190.042969 260.402344 136.816406 253.234375 112.144531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ece9ea",
    d: "M 463.757812 328.953125 L 408.1875 312.054688 L 422.683594 256.683594 Z M 463.757812 328.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdcd9",
    d: "M 554.886719 238.335938 C 554.886719 238.335938 493.484375 208.722656 422.683594 256.683594 L 463.757812 328.953125 L 513.398438 323.542969 L 526.734375 341.558594 L 540.074219 341.558594 C 540.074219 341.558594 558.59375 284.269531 554.886719 238.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdcd9",
    d: "M 693.4375 350.953125 L 679.734375 350.953125 L 667.503906 332.800781 L 635.277344 332.800781 L 631.203125 339.839844 L 621.941406 339.839844 L 626.015625 299.121094 C 626.015625 299.121094 676.769531 272.136719 733.074219 285.425781 L 693.4375 350.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#151c27",
    d: "M 581.363281 326.269531 L 565.671875 286.953125 C 565.671875 286.953125 597.234375 307.066406 621.035156 339.839844 L 631.203125 339.839844 L 635.277344 332.800781 L 667.503906 332.800781 L 679.734375 350.953125 L 674.597656 350.953125 L 665.222656 336.007812 L 637.085938 335.105469 L 633.480469 341.558594 L 616.886719 341.558594 L 581.363281 326.269531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#665d65",
    d: "M 563.035156 282.792969 C 563.035156 282.792969 599.582031 303.09375 621.941406 339.839844 L 619.773438 339.839844 C 619.773438 339.839844 601.15625 313.152344 568.015625 289.480469 L 581.363281 322.84375 L 577.933594 324.464844 L 563.035156 282.792969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ece9ea",
    d: "M 621.941406 339.839844 C 621.941406 339.839844 600.828125 306.871094 563.035156 282.792969 C 563.035156 282.792969 593.046875 278.410156 626.015625 299.121094 C 626.015625 299.121094 634.535156 324.648438 621.941406 339.839844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c2722",
    d: "M 590.378906 317.609375 L 547.636719 341.558594 L 616.886719 341.558594 C 616.886719 341.558594 606.25 324.28125 590.378906 317.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#867a73",
    d: "M 55.324219 386.140625 L 699.460938 386.140625 L 699.460938 360.980469 L 644.609375 341.558594 L 345.6875 341.558594 L 315.496094 329.585938 L 277.601562 329.585938 L 211.324219 305.117188 L 156.980469 305.117188 L 156.980469 328.953125 L 55.324219 328.953125 L 55.324219 345.628906 L 100.613281 345.628906 L 101.117188 354.078125 L 55.324219 354.078125 L 55.324219 386.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#30363c",
    d: "M 319.519531 374.566406 L 300.398438 374.566406 L 300.398438 339.839844 L 319.519531 339.839844 L 319.519531 374.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#30363c",
    d: "M 535.410156 386.140625 L 516.28125 386.140625 L 516.28125 357.203125 L 535.410156 357.203125 L 535.410156 386.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#30363c",
    d: "M 625.988281 386.140625 L 612.398438 386.140625 L 612.398438 366.515625 L 625.988281 366.515625 L 625.988281 386.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#30363c",
    d: "M 353.238281 386.140625 L 325.058594 386.140625 L 325.058594 371.671875 L 353.238281 371.671875 L 353.238281 386.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#30363c",
    d: "M 164.023438 386.140625 L 149.933594 386.140625 L 149.933594 363.996094 L 164.023438 363.996094 L 164.023438 386.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#30363c",
    d: "M 293.355469 357.203125 L 244.539062 357.203125 L 244.539062 350.953125 L 293.355469 350.953125 L 293.355469 357.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#30363c",
    d: "M 486.59375 357.203125 L 325.058594 357.203125 L 325.058594 350.953125 L 486.59375 350.953125 L 486.59375 357.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#30363c",
    d: "M 656.6875 357.203125 L 570.128906 357.203125 L 570.128906 350.953125 L 656.6875 350.953125 L 656.6875 357.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e31",
    d: "M 526.734375 341.558594 L 513.398438 323.542969 L 463.757812 328.953125 L 408.1875 312.054688 L 379.296875 341.558594 L 388.511719 341.558594 L 410.640625 317.972656 L 457.195312 332.324219 L 457.195312 341.558594 L 467.714844 341.558594 L 467.714844 332.871094 L 508.789062 328.953125 L 518.429688 341.558594 L 526.734375 341.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e31",
    d: "M 284.996094 329.585938 L 293.988281 307.523438 L 336.847656 314.667969 L 350.292969 341.558594 L 345.6875 341.558594 L 333.082031 318.851562 L 298.03125 312.054688 L 291.457031 329.585938 L 284.996094 329.585938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e31",
    d: "M 200.429688 305.117188 L 203.058594 294.640625 L 239.53125 303.617188 L 245.652344 317.789062 L 255.933594 321.585938 L 244.828125 299.960938 L 198.1875 289.875 L 194.472656 305.117188 L 200.429688 305.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a454498150)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#58524b",
    d: "M 749.03125 403.890625 L 0.800781 403.890625 L 0.800781 386.140625 L 749.03125 386.140625 L 749.03125 403.890625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#716762",
    d: "M 139.550781 328.953125 L 55.324219 328.953125 L 55.324219 345.628906 L 100.613281 345.628906 L 101.117188 354.078125 L 55.324219 354.078125 L 55.324219 386.140625 L 139.550781 386.140625 L 139.550781 328.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9684d07a79)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3a97a6",
    d: "M 749.03125 479.285156 L 0.800781 479.285156 L 0.800781 403.890625 L 749.03125 403.890625 L 749.03125 479.285156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfdcdd",
    d: "M 315.625 134.988281 C 335.765625 158.25 400.851562 243.8125 364.308594 341.558594 C 419.664062 298.992188 422.683594 256.683594 422.683594 256.683594 C 396.929688 191.328125 352.523438 154.917969 315.625 134.988281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfdcdd",
    d: "M 254.851562 186.25 C 276.710938 208.578125 312.921875 258.230469 272.738281 313.476562 C 276.207031 323.660156 277.601562 329.585938 277.601562 329.585938 L 284.996094 329.585938 L 293.988281 307.523438 C 293.988281 307.523438 335.585938 313.828125 336.847656 314.667969 C 338.109375 315.507812 350.292969 341.558594 350.292969 341.558594 L 358.273438 341.558594 C 345.25 261.304688 332.226562 242.816406 332.226562 242.816406 C 310.589844 215.171875 281.585938 197.496094 254.851562 186.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfdcdd",
    d: "M 152.914062 205.496094 C 170.703125 222.996094 192.089844 255.78125 182.222656 307.523438 L 193.984375 307.101562 L 198.1875 289.878906 L 244.828125 299.960938 L 255.933594 321.585938 L 272.738281 327.789062 C 262.238281 284.933594 236.621094 244.582031 236.621094 244.582031 C 212.757812 221.671875 181.527344 210.589844 152.914062 205.496094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ece9ea",
    d: "M 489.894531 230.421875 C 492.441406 255.148438 502.355469 313.050781 540.144531 341.335938 C 541.367188 337.472656 558.460938 282.628906 554.886719 238.335938 C 554.886719 238.335938 528.277344 225.507812 489.894531 230.421875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ece9ea",
    d: "M 675.113281 283.820312 C 674.445312 304.503906 676.910156 333.433594 692.960938 350.953125 L 693.4375 350.953125 L 733.074219 285.425781 C 712.226562 280.503906 692.144531 281.109375 675.113281 283.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.109a58504731309f6d8a896aea5ba2b1.svg";
export { ForwardRef as ReactComponent };